import SmartButton from './SmartButton'
import { SmartButton as SmartButtonModel } from 'api'
import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';

const smartButtonContainer = (sourceModelName, View, { Source } = { }) => {
  const SmartButtonContainer = (props) => {
    const [state, setState] = useState({ smartButtons: null })
    const prevPropsRef = useRef({})
    const mountedRef = useRef(true)
    const xhrRef = useRef(null)

    useEffect(() => {
      reload()
      return () => {
        xhrRef.current && xhrRef.current.abort()
        mountedRef.current = false
      }
    }, [])

    useEffect(() => {
      const prevProps = prevPropsRef.current
      if (props[sourceModelName] && prevProps[sourceModelName] &&
          (props[sourceModelName].id != prevProps[sourceModelName].id ||
          props[sourceModelName].updated_at != prevProps[sourceModelName].updated_at)) {
        reload()
      }
      prevPropsRef.current = props
    })

    const reload = () => {
      let source = Source || props[sourceModelName]
      let currentSource = source
      if (source.requestSmartButtons)
        return xhrRef.current = source.requestSmartButtons(smartButtons => {
          currentSource = null
          if (mountedRef.current !== false)
            setState({ smartButtons })
        })
    }

    return <View {...props} {...state} reloadSmartButtons={reload} />
  }

  return SmartButtonContainer
}


const SmartButtonList = smartButtonContainer('smartButtonSource', ({smartButtons, reloadSmartButtons, base, className, onClickSmartButton}) => {
  if (smartButtons == null || smartButtons.length == 0 || (App.embed == true)) return null
  return (
    <div>
      {smartButtons.map((smartButton, index) => (
        <>
          <SmartButton {...{ smartButton, reloadSmartButtons, base }} key={smartButton.key} className="custom-smart-button" onClick={() => onClickSmartButton?.()} />
          {index < smartButtons.length - 1 && <Dropdown.Divider />}
        </>
      ))}
    </div>
  )
})

const SmartButtonFeedList = ({base, source, onClickSmartButton} = {}) =>
  <div>
    <SmartButtonList smartButtonSource={source || SmartButtonModel.feedSource} base={base} onClickSmartButton={onClickSmartButton} />
  </div>


export { smartButtonContainer, SmartButtonList, SmartButtonFeedList }
